import {ApiResourceModel} from "./api-resource.model";
import {StockVariantOptionModel} from "./stock-variant-option.model";
import {StockVariantOptionValueModel} from "./stock-variant-option-value.model";

export class ProductOperationItemVariantOptionModel extends ApiResourceModel{
  public variantOption: StockVariantOptionModel|string;
  public variantOptionValues: StockVariantOptionValueModel[]|string[];
}
